// extracted by mini-css-extract-plugin
export default {"container":"container-8976","item":"item-8109","full-width":"full-width-1b5d","doubles":"doubles-df99"};